import 'parsleyjs';

$(document).on('ready', function () {
    $('.parsley-form').each(function () {
        $(this).parsley();
    });
});
